import { z } from "zod/v4";

import { LiteralSchema } from "../../../utils";

export const ShopifyGraphqlRequestBodySchema = z.object({
  operationName: z.string().optional(),
  query: z.string(),
  variables: z.record(z.string(), LiteralSchema),
});

export type ShopifyGraphqlRequestBodyType = z.infer<
  typeof ShopifyGraphqlRequestBodySchema
>;
